import React from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { FormField } from 'components/formKit'
import type { FONT_LINK_FIELDS } from 'services/Branding/fieldConfigs'

export interface IDefaultLinkFontFormProps {
  font: typeof FONT_LINK_FIELDS
  children?: React.ReactNode
}

const DefaultLinkFontForm: React.FC<IDefaultLinkFontFormProps> = ({ font, children }) => {
  return (
    <Padding gap sides>
      {children}
      <FormField config={font.color} />
      <FormField config={font.textDecoration} />
      <FormField config={font.hoverColor} />
    </Padding>
  )
}

export default DefaultLinkFontForm
